import BaseWrapper from "../../components/ui/BaseWrapper";
import BaseButton from "../../components/ui/BaseButton";
import { useState } from "react";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import CompleteProfileModal from "../WorkJobDetails/CompleteProfileModal";
import useAuth from "../../hooks/useAuth";
import { ModuleType, UserType } from "../../utils/enum";

const WorkForceListingHeader = () => {
  const { userData } = useCurrentUser();
  const { authRole, getPermissionForModule } = useAuth();
  // Inviting into the workforce is never a customer's action — hidden for them
  // outright, regardless of how their permissions happen to be configured. For
  // clients it stays permission-driven, so it can be granted per designation.
  const { hasWriteAccess } = getPermissionForModule(ModuleType.WORK_FORCE_ENGINEERS);
  const canInviteWorkforce = authRole !== UserType.CUSTOMER && hasWriteAccess;
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);

  return (
    <>
      <div className="border-b border-zinc-300 bg-white">
        <BaseWrapper>
          <div className="py-[7px] flex justify-between">
            <h3 className="font-light">Workforce</h3>
            {canInviteWorkforce && (
              <div>
                <BaseButton
                  color="primary"
                  className="py-[4px] px-[28px]"
                  onClick={() => {
                    if (userData?.status !== "APPROVED") {
                      setIsProfileCompleted(true);
                      return;
                    }
                  }}
                >
                  Invite Workforce
                </BaseButton>
              </div>
            )}
          </div>
        </BaseWrapper>
      </div>

      {isProfileCompleted && (
        <CompleteProfileModal
          isProfileCompleted={isProfileCompleted}
          setIsProfileCompleted={setIsProfileCompleted}
          status={userData?.status}
          authRole={authRole}
        />
      )}
    </>
  );
};

export default WorkForceListingHeader;
